import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
} from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { ForegroundSemantic2og103ajpnjfv as ForegroundSemantic } from '../theming/colorManagement.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_arrowUp74ixc3ej28d5 as get_arrowUp } from '../../icons.mjs';
import {
  Companion_getInstanceeghlbkcb6su6 as Companion_getInstance_0,
  Angle36m0cdko0c63j as Angle,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Angle.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_rem14pbkv8p42gid as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { space2ppi73m2qk1br as space } from './space.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance } from '../theming/Titles.mjs';
import {
  get_rotation2o00xy9g08m4u as get_rotation,
  set_rotationrdhjwh8aps06 as set_rotation,
} from '../../actuals/rotation.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function priceArrowIcon(_this__u8e3s4, removeIfNull, price) {
  removeIfNull = removeIfNull === VOID ? false : removeIfNull;
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (IconView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  if (removeIfNull) {
    var tmp = KMutableProperty0();
    var tmp_0 = IconView$_get_shown_$ref_js8irt(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, IconView$_set_shown_$ref_9ilxmr(view));
    reactiveScope(view, ($this$reactiveScope) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var tmp = price($this$reactiveScope);
      var tmp_0 = tmp == null ? null : tmp.a5s_1;
      // Inline function 'kotlin.let' call
      var tmp_1 = tmp_0 == null ? null : new (MonetaryValue())(tmp_0);
      var it = tmp_1 == null ? null : tmp_1.a5s_1;
      var tmp_2;
      var tmp_3 = it;
      if (!((tmp_3 == null ? null : new (MonetaryValue())(tmp_3)) == null)) {
        var tmp_4 = it;
        tmp_2 = !equals(tmp_4 == null ? null : new (MonetaryValue())(tmp_4), new (MonetaryValue())(Companion_instance.p91(0n)));
      } else {
        tmp_2 = false;
      }
      var tmp$ret$3 = tmp_2;
      this_0.set(tmp$ret$3);
      return Unit_instance;
    });
  } else {
    var tmp_1 = KMutableProperty0();
    var tmp_2 = IconView$_get_visible_$ref_7ldslk(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('visible', 0, tmp_1, tmp_2, IconView$_set_visible_$ref_mp0dqc(view));
    reactiveScope(view, ($this$reactiveScope) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var tmp = price($this$reactiveScope);
      var tmp_0 = tmp == null ? null : tmp.a5s_1;
      // Inline function 'kotlin.let' call
      var tmp_1 = tmp_0 == null ? null : new (MonetaryValue())(tmp_0);
      var it = tmp_1 == null ? null : tmp_1.a5s_1;
      var tmp_2;
      var tmp_3 = it;
      if (!((tmp_3 == null ? null : new (MonetaryValue())(tmp_3)) == null)) {
        var tmp_4 = it;
        tmp_2 = !equals(tmp_4 == null ? null : new (MonetaryValue())(tmp_4), new (MonetaryValue())(Companion_instance.p91(0n)));
      } else {
        tmp_2 = false;
      }
      var tmp$ret$8 = tmp_2;
      this_1.set(tmp$ret$8);
      return Unit_instance;
    });
  }
  dynamicTheme(view, ($this$dynamicTheme) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp = price($this$dynamicTheme);
    var tmp_0 = tmp == null ? null : tmp.a5s_1;
    // Inline function 'kotlin.let' call
    var tmp_1 = tmp_0 == null ? null : new (MonetaryValue())(tmp_0);
    var it = tmp_1 == null ? null : tmp_1.a5s_1;
    var tmp_2;
    var tmp_3;
    var tmp_4 = it;
    if ((tmp_4 == null ? null : new (MonetaryValue())(tmp_4)) == null) {
      tmp_3 = true;
    } else {
      var tmp_5 = it;
      tmp_3 = equals(tmp_5 == null ? null : new (MonetaryValue())(tmp_5), new (MonetaryValue())(Companion_instance.p91(0n)));
    }
    if (tmp_3) {
      tmp_2 = null;
    } else {
      if (MonetaryValue__compareTo_impl_w7ul1r(it, Companion_instance.p91(0n)) > 0) {
        tmp_2 = ForegroundSemantic().agi(AppColors_getInstance().dfz_1.xg9_1);
      } else {
        tmp_2 = ForegroundSemantic().agi(AppColors_getInstance().hfz_1.xg9_1);
      }
    }
    return tmp_2;
  });
  view.qbt(get_arrowUp(Companion_getInstance()));
  var tmp_3 = KMutableProperty0();
  var tmp_4 = IconView$_get_description_$ref_x7iif6(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('description', 0, tmp_3, tmp_4, IconView$_set_description_$ref_rpvc1e(view));
  reactiveScope(view, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp = price($this$reactiveScope);
    var tmp_0 = tmp == null ? null : tmp.a5s_1;
    // Inline function 'kotlin.let' call
    var tmp_1 = tmp_0 == null ? null : new (MonetaryValue())(tmp_0);
    var it = tmp_1 == null ? null : tmp_1.a5s_1;
    var tmp_2;
    var tmp_3;
    var tmp_4 = it;
    if ((tmp_4 == null ? null : new (MonetaryValue())(tmp_4)) == null) {
      tmp_3 = true;
    } else {
      var tmp_5 = it;
      tmp_3 = equals(tmp_5 == null ? null : new (MonetaryValue())(tmp_5), new (MonetaryValue())(Companion_instance.p91(0n)));
    }
    if (tmp_3) {
      tmp_2 = 'Unchanged';
    } else {
      if (MonetaryValue__compareTo_impl_w7ul1r(it, Companion_instance.p91(0n)) > 0) {
        tmp_2 = 'Increased';
      } else {
        tmp_2 = 'Decreased';
      }
    }
    var tmp$ret$16 = tmp_2;
    this_2.set(tmp$ret$16);
    return Unit_instance;
  });
  var tmp_5 = KMutableProperty0();
  var tmp_6 = _get_rotation_$ref_mwbk4(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('rotation', 0, tmp_5, tmp_6, _set_rotation_$ref_g6n248(view));
  reactiveScope(view, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp = price($this$reactiveScope);
    var p = tmp == null ? null : tmp.a5s_1;
    var tmp_0;
    var tmp_1;
    var tmp_2 = p;
    if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
      tmp_1 = true;
    } else {
      tmp_1 = MonetaryValue__compareTo_impl_w7ul1r(p, Companion_instance.p91(0n)) >= 0;
    }
    if (tmp_1) {
      tmp_0 = Companion_getInstance_0().eb2_1;
    } else {
      tmp_0 = Companion_getInstance_0().gb2_1;
    }
    var tmp$ret$19 = new (Angle())(tmp_0);
    this_3.set(tmp$ret$19);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return view;
}
function priceWithChange(_this__u8e3s4, addPadding, price, change) {
  addPadding = addPadding === VOID ? true : addPadding;
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.zb8(get_rem(0.2));
  if (addPadding) {
    space(view, get_rem(0.7));
  }
  var tmp = get_centered(view);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.jba(view_0.ob6_1.ybe(BodySemantic_getInstance()));
  view_0.bbs(Align_Center_getInstance());
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$0 = price($this$reactiveScope).a5s_1;
    var tmp$ret$1 = MonetaryValue__toString_impl_xslc77(tmp$ret$0);
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  view.jbb(get_centered(view), priceArrowIcon(view, !addPadding, change));
  _this__u8e3s4.fbb(p, view);
  return view;
}
function renderPriceChange(_this__u8e3s4, addPadding, change) {
  addPadding = addPadding === VOID ? true : addPadding;
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.zb8(get_rem(0.2));
  if (addPadding) {
    space(view, get_rem(0.7));
  }
  var tmp = get_centered(view);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.jba(view_0.ob6_1.ybe(BodySemantic_getInstance()));
  view_0.bbs(Align_Center_getInstance());
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_0(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_0(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp = change($this$reactiveScope);
    var tmp0_elvis_lhs = tmp == null ? null : tmp.a5s_1;
    var tmp_0;
    var tmp_1 = tmp0_elvis_lhs;
    if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
      tmp_0 = Companion_instance.o62(0);
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tmp$ret$1 = MonetaryValue__toString_impl_xslc77(tmp_0);
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  view.jbb(get_centered(view), priceArrowIcon(view, !addPadding, change));
  _this__u8e3s4.fbb(p, view);
  return view;
}
function IconView$_get_shown_$ref_js8irt(p0) {
  return () => p0.wb8();
}
function IconView$_set_shown_$ref_9ilxmr(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function IconView$_get_visible_$ref_7ldslk(p0) {
  return () => p0.yb8();
}
function IconView$_set_visible_$ref_mp0dqc(p0) {
  return (_this__u8e3s4) => {
    p0.xb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function IconView$_get_description_$ref_x7iif6(p0) {
  return () => p0.pbt_1;
}
function IconView$_set_description_$ref_rpvc1e(p0) {
  return (_this__u8e3s4) => {
    p0.ebu(_this__u8e3s4);
    return Unit_instance;
  };
}
function _get_rotation_$ref_mwbk4(p0) {
  return () => {
    var tmp0 = p0;
    return new (Angle())(get_rotation(tmp0));
  };
}
function _set_rotation_$ref_g6n248(p0) {
  return (_this__u8e3s4) => {
    var tmp0 = p0;
    set_rotation(tmp0, _this__u8e3s4.ycx_1);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
//region block: exports
export {
  priceWithChange as priceWithChangedayxt0y21soj,
  renderPriceChange as renderPriceChangegxsbuhvani39,
};
//endregion

//# sourceMappingURL=priceChanges.mjs.map
